import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CountryDetailTab from './CountryDetailTab';
import useDetailHandler from '../../hooks/useDetailHandler';
import { countryType } from '../../types';
import './_styles_/CountryRow.css';
import { onActionKey } from '../../utils';

export const getValueMapping = (t) => ({
    active: [
        {
            from: true,
            to: t('misc.yes'),
        },
        {
            from: false,
            to: t('misc.no'),
        },
    ],
});

CountryRow.propTypes = {
    country: countryType.isRequired,
};

function CountryRow(props) {
    const { country } = props;
    const { t } = useTranslation();
    const valueMapping = getValueMapping(t);
    const { isDetailVisible, toggleDetail } = useDetailHandler(country.id);
    return (
        <>
            <div className="rich-list-row country-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="country-header--values--name">{country.name}</div>
                <div className="country-header--values--code">{country.code}</div>
                <div className="country-header--values--active">{country.active ? valueMapping.active[0].to : valueMapping.active[1].to}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && <CountryDetailTab country={country} />}
        </>
    );
}

export default CountryRow;
